module.exports = __webpack_public_path__ + "img/coin50.3e322d76.png";